import { useGetTemplateVersions } from 'entities/template/api/hooks';

export const useTemplateHistory = (templateId: string) =>
  useGetTemplateVersions({ pathParams: { templateId } });
